<template>
  <page-frame bodyStyle="top:2.12rem;">
    <header-bar slot="head">
      <span>{{ title }}</span>
    </header-bar>
    <div style="width:100%;height:100%;position: relative">
      <div style="width:100%;height:100%;font-size:12px" id="map"></div>
      <!-- <div style="position:absolute;left: 0;top: 0;" @click="resizePosition">{{$t('modules_webmap_dingwei')}}</div> -->
    </div>
  </page-frame>
</template>
<style scoped>
  /* .appInner .hotelBooking-main span {
    top: 0.3rem;
  }

  .iphoneX .hotelBooking-main span {
    top: 0.5rem;
  }

  .header-menu {
    background-color: #12a3ff;
  } */
</style>
<script>
  // import navBar from '../../modules/navBar.vue'
  export default {
    data() {
      return {
        map: {},
      };
    },
    computed: {
      title() {
        return this.$route.query.title;
      },
      Latitude() {
        return this.$route.query.latitude;
      },
      Longitude() {
        return this.$route.query.longitude;
      },
    },
    mounted() {
      let __self = this;
      if (window.BMap) {
        __self.__init();
      } else {
        let id = "webMapBaiduApi";
        let s = document.getElementById(id);
        let loadScript = () => {
          window.webMapLoad = () => __self.__init();
          s = document.createElement("script");
          s.id = id;
          s.type = "text/javascript";
          s.src = "https://api.map.baidu.com/api?v=2.0&ak=B3f7707c25da5b29a6ff69618788a296&callback=webMapLoad";
          document.body.appendChild(s);
        };
        if (!s) {
          loadScript();
        } else {
          setTimeout(() => {
            if (!window.BMap) {
              loadScript();
            }
          }, 2000);
        }
      }
    },
    methods: {
      __init() {
        let __self = this;
        var Latitude = __self.Latitude;
        var Longitude = __self.Longitude;
        var map;
        //创建和初始化地图函数：

        function initMap() {
          createMap(); //创建地图
          setMapEvent(); //设置地图事件
          //   addMapControl(); //向地图添加控件
          //   addMapOverlay(); //向地图添加覆盖物
        }

        function createMap() {
          let __self = this;
          map = new BMap.Map("map");
          map.centerAndZoom(new BMap.Point(Longitude, Latitude), 19);
          var marker = new BMap.Marker(new BMap.Point(Longitude, Latitude), 19); // 创建标注
          map.addOverlay(marker);
        }

        function setMapEvent() {
          map.enableScrollWheelZoom();
          map.enableKeyboard();
          map.enableDragging();
          map.enableDoubleClickZoom();
        }

        function addClickHandler(target, window) {
          target.addEventListener("click", function() {
            target.openInfoWindow(window);
          });
        }

        function addMapOverlay() {
          var markers = [
            {
              content: this.$root.$t("modules_webmap_wodebeizhu"),
              title: this.$root.$t("modules_webmap_wodebiaoji"),
              imageOffset: {
                width: 0,
                height: 3,
              },

              position: {
                lat: Longitude,
                lng: Latitude,
              },
            },
          ];
          for (var index = 0; index < markers.length; index++) {
            var point = new BMap.Point(markers[index].position.lng, markers[index].position.lat);
            var marker = new BMap.Marker(point, {
              icon: new BMap.Icon("http://api.map.baidu.com/lbsapi/createmap/images/icon.png", new BMap.Size(20, 25), {
                imageOffset: new BMap.Size(markers[index].imageOffset.width, markers[index].imageOffset.height),
              }),
            });
            var label = new BMap.Label(markers[index].title, {
              offset: new BMap.Size(25, 5),
            });
            var opts = {
              width: 200,
              title: markers[index].title,
              enableMessage: false,
            };
            var infoWindow = new BMap.InfoWindow(markers[index].content, opts);
            marker.setLabel(label);
            addClickHandler(marker, infoWindow);
            map.addOverlay(marker);
          }
        }
        //向地图添加控件
        function addMapControl() {
          var scaleControl = new BMap.ScaleControl({
            anchor: BMAP_ANCHOR_BOTTOM_LEFT,
          });
          scaleControl.setUnit(BMAP_UNIT_METRIC);
          map.addControl(scaleControl);
          var navControl = new BMap.NavigationControl({
            anchor: BMAP_ANCHOR_TOP_LEFT,
            type: 1,
          });
          map.addControl(navControl);
          var overviewControl = new BMap.OverviewMapControl({
            anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
            isOpen: false,
          });
          map.addControl(overviewControl);
        }
        __self.map = map;
        __self.$nextTick(() => {
          initMap();
        });
      },
      back() {
        history.back();
      },
      resizePosition() {
        let __self = this;
        var Latitude = __self.Latitude;
        var Longitude = __self.Longitude;
        var map = new BMap.Map("map");
        map.centerAndZoom(new BMap.Point(Longitude, Latitude), 19);
        map.enableScrollWheelZoom(true);
        map.clearOverlays();
        var new_point = new BMap.Point(Longitude, Latitude, 19);
        var marker = new BMap.Marker(new_point); // 创建标注
        map.addOverlay(marker); // 将标注添加到地图中
        map.panTo(new_point);
      },
    },
  };
</script>
